<template>

	<div class="bkf7 add_order_wbox" style=";margin-top: 0;">
		<el-container>



			<div class="inter">
				<el-row>
					<div class="w_div ">
						<div class="n_de_ti" style="margin-top: 10px;">商品信息</div>
						<div class="div1 t-flex" v-show="!loading">
							<div class="image">
								<el-image :src="goods.image" :preview-src-list="info.banner"
									v-show="!loading"></el-image>
							</div>
							<div class="text">
								<p class="p1"> {{ goods.title }}</p>
								<div class="p2 t-flex t-flex-items-center t-flex-between">

									<div class="fl">
										<span>售价：</span> <span class="current-price">{{ goods.price }}元</span>
									</div>
									<div class="fr"><span>游戏区服：</span> <span class="sp2">{{ daqu.text }}</span>
									</div>
								</div>
							</div>

						</div>
						<div v-show="loading">
							<el-skeleton :rows="3" animated />
						</div>
					</div>

					<div class="w_div ">
						<div class="n_de_ti" style="margin-top: 10px;">账号保障</div>
						<div class="indemnity_box_all" style="margin-bottom: 30px;">
							<div class="indemnity_box_top">
								<h4 class="flex">
									红六
									<!-- <span class="colorRed">基础</span> -->
									<span class="colorRed">找回包赔</span>
								</h4>
								<!-- <p>（可单选）</p> -->
							</div>
							<div class="indemnity_box">
								<div :class="{'indemnity_change':baopei_type == 1}">
									<div class="indemnity_box_title">
										<h4>找回包赔</h4>
										<div>
											<p>
												最高赔付
												<span :class="{'indemnity_change_color':baopei_type == 1}">100%
												</span>
											</p>
											<img @click="visible = true"
												:src="require(`@/assets/image/indemnity_box_tip.png`)">
										</div>
									</div>

									<div class="indemnity_box_content">
										<div class="indemnity_box_content_introduction" v-if="info.admin_id != 29">
											0手续费，账号若发生找回，7个工作日未追回可申请全额赔付</div>
										<div class="indemnity_box_content_introduction" v-if="info.admin_id == 29">
											5%手续费，账号若发生找回，7个工作日未追回可申请全额赔付</div>
										<div class="indemnity_box_footer">
											<div>¥{{shouxufei}}</div>

											<img :src="require(`@/assets/image/radio_icon.png`)" @click="changeType(1)"
												v-if="baopei_type != 1" class="orderInfoConfirm_radio">
											<img :src="require(`@/assets/image/radio_icon_active.png`)"
												@click="changeType(0)" v-if="baopei_type == 1"
												class="orderInfoConfirm_radio">
										</div>
									</div>
								</div>
								<div :class="{'indemnity_change':baopei_type == 2}">
									<div class="indemnity_box_title">
										<h4>充值包赔</h4>
										<div>
											<p>
												最高赔付
												<span :class="{'indemnity_change_color':baopei_type == 2}">300%
												</span>
											</p>
											<img @click="visible = true"
												:src="require(`@/assets/image/indemnity_box_tip.png`)">
										</div>
									</div>

									<div class="indemnity_box_content">
										<div class="indemnity_box_content_introduction">
											10%手续费，账号若发生找回，7个工作日未追回可申请最高300%赔付</div>
										<div class="indemnity_box_footer">
											<div>¥{{ parseFloat(goods.price * 0.1).toFixed(2)}}</div>

											<img :src="require(`@/assets/image/radio_icon.png`)" @click="changeType(2)"
												v-if="baopei_type != 2" class="orderInfoConfirm_radio">
											<img :src="require(`@/assets/image/radio_icon_active.png`)"
												@click="changeType(0)" v-if="baopei_type == 2"
												class="orderInfoConfirm_radio">
										</div>
									</div>
								</div>

							</div>
						</div>
						<div class="confirm_order_box"><!---->
							<div class="orderInfoConfirm_button_box">
								<div class="orderInfoConfirm_button_read">
									<div class="orderInfoConfirm_radio_box"><img
											:src="require(`@/assets/image/radio_icon.png`)" @click="xuzhi = !xuzhi"
											v-if="!xuzhi" class="orderInfoConfirm_radio">
										<img :src="require(`@/assets/image/radio_icon_active.png`)"
											@click="xuzhi = !xuzhi" v-if="xuzhi" class="orderInfoConfirm_radio">
										<div>
											我已阅读并同意
											<span @click="visible2 = true">《购买须知》</span>
										</div>
									</div>

								</div>
								<div class="orderInfoConfirm_radio_mony"><span class="actual"><span
											class="actual_label">实付款:</span> <span class="actual_rmb_symbol">￥</span>
										{{price}}
									</span> </div>
								<div class="orderInfoConfirm_button_3">

									<div @click="addOrder">立即支付</div>
								</div>
							</div>
						</div>
					</div>

				</el-row>
			</div>
		</el-container>


		<el-dialog :visible.sync="visible" :center="true" custom-class="dialogColor2" title="包赔服务" width="600px"
			destroy-on-close @closed="visible = false">
			<div class="compensationModel_box">
				<div>
					<div class="compensationModel_box_title">

						<img :src="require(`@/assets/image/baopei_icon.png`)" alt="">

						<span>包赔规则</span>
					</div>
					<div>
						<p>账号发生恶意找回需在七个工作日内必须联系售后处理</p>
						<p>超过七个工作日再联系平台，包赔无效</p>
						<p>(安全中心技术部门反馈申诉记录只保留七个工作日）</p>
						<p>红六游戏在七个工作日以内未能成功帮助买家追回账号进行赔付</p>
					</div>
				</div>
				<div>
					<div class="compensationModel_box_title">





						<img :src="require(`@/assets/image/zhuyi_icon.png`)" alt=""> <span>注意事项</span>
					</div>
					<div>
						<p>若私下更换密保手机或脱离平台交易，包赔将无效</p>
					</div>
				</div>
			</div>
		</el-dialog>


		<el-dialog :visible.sync="visible2" :center="true" custom-class="dialogColor2" title="购买须知" width="800px"
			destroy-on-close @closed="visible2 = false">
			<div class="compensationModel_box">
				<div v-if="jiaoyi && jiaoyi.archivesInfo" v-html="jiaoyi.archivesInfo.content">

				</div>
			</div>
		</el-dialog>


		<el-dialog :visible.sync="payvisible" :center="true" custom-class="pay_dialog" title="收银台" width="544px"
			destroy-on-close @closed="close">
			<div class="pay_dialog_page">
				<div class="scan_operat">
					<div class="scan_area">
						<p class="scan_area_title">请打开支付宝扫一扫</p>
						<div class="qr-box">
							<div ref="qrcode" id="qrcodePay" style="display: inline-block;">


							</div>

						</div>
						<p class="pay_risk" style="display: none;">订单已超时取消，请重新下单</p>
						<div class="pay_risk">
							<el-statistic format="mm:ss" :value="pay_info.expiretime*1000" time-indices title="">
							</el-statistic>
							后二维码失效
						</div>
					</div>
					<div class="scan_control">
						<p class="scan_control_price">
							应付金额：
							<span>¥{{pay_info.price}}</span>
						</p>
						<div class="scan_control_option">
							<div>

								<img :src="require(`@/assets/image/alipay.png`)" alt="ALIPAY">
								<span>支付宝</span>
							</div> <img :src="require(`@/assets/image/radio_icon_active.png`)" alt="选择支付方式"
								class="option_single_choice">

						</div>

						<p class="scan_control_tips">为确保您当前交易的安全，扫描二维码后会进行安全验证！</p>
					</div>
				</div>
			</div>
		</el-dialog>



	</div>


</template>
<script>
	import {
		Notification,
		Message
	} from 'element-ui'
	import QRCode from 'qrcodejs2';
	export default {
		data() {
			return {
				goods: {},
				goods_id: 0,
				loading: true,
				info: {},
				daqu: {},
				baopei_type: 0,
				shouxufei: 0,
				price: 0,
				visible: false,
				visible2: false,
				jiaoyi: {},
				xuzhi: false,
				payvisible: false,
				pay_info: {}

			}
		},
		created: function(data) {

			this.goods_id = this.$route.query.id

			if (this.goods_id == undefined) {
				this.goods_id = this.$route.params.id
			}




			this.getDetail(this.goods_id);
			this.getJiaoyi();


		},
		watch: {
			baopei_type(v) {

				if (v == 1) {
					this.price = parseFloat(this.goods.price) + parseFloat(this.shouxufei)
				} else if (v == 2) {
					var now_price = parseFloat(this.goods.price * 0.1).toFixed(2);
					this.price = parseFloat(this.goods.price) + parseFloat(now_price)
				} else {
					this.price = this.goods.price
				}


			},
			$route() {

			}
		},
		methods: {
			changeType(item) {
				this.baopei_type = item
			},
			close() {
				this.payvisible = false;
				var that = this;
				setTimeout(function() {
					that.$router.push("/order")

				}, 500);
			},

			getDetail(id) {
				var that = this;

			},

			payOrder(id) {
				var that = this;
				this.rq.requests.post("api/index/payOrder", {
					id: id,
				}).then(res => {
					if (res.code == 1) {
						that.payvisible = true
						that.pay_info = res.data
						setTimeout(function() {
							new QRCode(document.getElementById("qrcodePay"), {
								text: that.pay_info.pay.qr_code,
								width: 130,
								height: 130
							});

						}, 500);

						const intervalId = setInterval(() => {
							this.rq.requests.post("api/order/detail", {
								id: id,
							}).then(res => {
								if (res.data.status == '1') {
									clearInterval(intervalId);
									that.$router.push("/order")
								}
							}).catch(error => {
								clearInterval(intervalId);
							})
						}, 5000);
					}
				}).catch(res => {
					Message.error({
						message: res.msg,
						duration: 3000,
						offset: "580"
					})
				})
			},
			getJiaoyi() {
				var that = this;
				this.rq.requests.post("addons/cms/wxapp.Archives/detail2", {
					id: 784348,
				}).then(res => {
					that.jiaoyi = res.data;

				}).catch(error => {

				})
			},
			addOrder() {

				if (this.xuzhi == false) {
					Message.error({
						message: "请阅读并勾选购买须知",
						duration: 3000,
						offset: "580"
					})
					return;
				}

				var xuzhi = 0;
				if (this.xuzhi) {
					xuzhi = 1
				}

				var baobei = 0;
				if (this.baopei_type) {
					baobei = 1
				}


				var that = this;
				this.rq.requests.post("api/Order/addorder", {
					id: that.goods_id,
					baopei: this.baopei_type,

				}).then(res => {


					if (res.data.status == 1) {
						that.$router.push("/orderDetail?id=" + res.data.id)
						return;
					} else {
						that.payOrder(res.data.id)
					}

				}).catch(res => {


					Message.error({
						message: res.msg,
						duration: 3000,
						offset: "580"
					})
				})
			},
			getDetail(id) {
				var that = this;
				this.rq.requests.post("api/hall/ArchivesDetail", {
					id: id,
				}).then(res => {

					that.info = res.data;
					that.goods = res.data.archives;
					that.shouxufei = 0;

					if (that.goods.model_id == 7 && that.goods.account_id == 29) {
						that.shouxufei = parseFloat(that.goods.price * 0.05).toFixed(2)
					}

					that.daqu = res.data.daqu;
					that.price = that.goods.price
					that.loading = false;

				}).catch(error => {

				})
			},


		}
	}
</script>
<style>
	.zuhao .el-radio__input {
		display: flex !important;
		align-items: center;
	}

	.zuhao .el-radio__input.is-checked .el-radio__inner {
		border-color: #fe6730;
		background: #fe6730;
	}

	.zuhao .el-radio__input.is-checked+.el-radio__label {
		color: #fe6730;
	}
</style>